import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'flex px-2 text-[10px] font-semibold transition-colors border border-transparent min-w-6 justify-center items-center shrink-0 translate-y-0 gap-1.5 leading-[1]',
  {
    variants: {
      variant: {
        default: 'bg-gray-950 text-gray-50',
        secondary: 'bg-gray-100 text-gray-950 border-transparent',
        destructive: 'bg-red-500 text-gray-50',
        warning: 'bg-amber-500 text-black',
        discount: 'bg-pink-50 text-pink-700 border-pink-200',
        outline: 'text-gray-950 border-gray-800',
        green: 'bg-green-500 text-gray-50',
        'green-outline': 'bg-green-50 text-green-600 border-green-500',
        'destructive-outline': 'bg-red-50 text-red-600 border-red-500',
        'warning-outline': 'bg-amber-50 text-amber-600 border-amber-400',
      },
      size: {
        default: 'h-4 text-[9px] px-2 rounded-[5px]',
        md: 'h-5 text-[11px] px-2 rounded-[5px]',
        lg: 'h-6 text-[11px] px-3 rounded-md',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
